import { styled, TableRow, TableRowProps } from "@mui/material";

const StyledTableRow = styled(TableRow)<TableRowProps>(({ theme }) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    }
  }
}));

export default StyledTableRow;
